/* Irene Quirós · columna de información de la ficha.
   En ordenador la columna es «pegajosa» (sticky). Si es más alta que la ventana (p. ej. 1440×900 o 1366×768),
   con un «top» fijo el botón «Añadir al carrito» quedaba fuera de la pantalla mientras se recorre la galería.
   Aquí se ajusta el «top» para que la columna se desplace hasta mostrar su final (botón incluido) y solo entonces se fije. */
(function () {
  'use strict';
  var cols = [];
  function fit() {
    cols.forEach(function (d) {
      d.style.top = '';
      var cs = getComputedStyle(d);
      if (cs.position !== 'sticky') return;
      var top = parseFloat(cs.top) || 0;
      var h = d.getBoundingClientRect().height;
      var vh = window.innerHeight;
      if (h + top + 16 > vh) d.style.top = Math.round(vh - h - 16) + 'px';
    });
  }
  function init() {
    cols = [].slice.call(document.querySelectorAll('.product-details'));
    if (!cols.length) return;
    fit();
    window.addEventListener('resize', fit);
    if (window.ResizeObserver) {
      var t = null;
      var ro = new ResizeObserver(function () { clearTimeout(t); t = setTimeout(fit, 60); });
      cols.forEach(function (d) { ro.observe(d); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', fit);
})();